// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4969) return "static/chunks/4969-60e3d42aa61d753c.js";
	if (chunkId === 5081) return "static/chunks/5081-010e42c3b7b779e8.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3846":"946c471a4c3b4ed6","6765":"6a48c886ebd1ada7","9966":"c33fbb0eebde0a08"}[chunkId] + ".js";
};